import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import { Chip, Paper, Grid, Button, LinearProgress, CircularProgress, Badge } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIosSharp';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIosSharp';
import WarningIcon from '@material-ui/icons/WarningRounded';


const styles = theme => ({
    layoutRoot: {},
    indikatorLoading: {
        width: '100%',
        textAlign: 'center'
    },
    judulPertanyaan: {
        color: '#434343'
    },
    paperWarningSave : {
        borderRadius: 0,
        padding: 5,
        background: '#FFEB3B',
        color: 'black',
        textAlign: 'center',
        fontSize: '11px',
        position: 'absolute',
        width: '100%',
        zIndex: '999999',
        top: '65px',
        boxShadow: '0px 0px'
    },
    FabSimpan: {
        position: 'fixed',
        bottom: 25,
        right: 30,
        zIndex: 999999
    },
    panelPengawas: {
        background: '#eeeeee'
    },
    linearColorPrimary: {
        backgroundColor: '#b2dfdb',
    },
    linearBarColorPrimary: {
        backgroundColor: '#7CB342',
        // backgroundColor: '#00695c',
    },
    snackbarNotifikasi: {
        zIndex: 999999
    }
});

// function Transition(props) {
//     return <Slide direction="up" {...props} />;
// }

class TransisiInstrumen extends Component {
    state = {
        error: null,
        isLoaded: false,
        namaJudul: '',
        bottom: false,
        ListMenu: null,
        email: null,
        instrumen_id: null,
        tampilPertanyaan: (<div style={{textAlign: 'center', width: '100%'}}><CircularProgress/></div>),
        total: 0,
        nomor: 1,
        persentase: 0,
        tombolDisabled: false,
        canSubmit: false,
        checkedR: [],
        checkTes: true,
        tampilLoading: 'block',
        routeParams: {
            token: null,
            start: 0,
            limit: 20,
            pengguna_id: null,
            load_children: 0,
            tingkat_instrumen: 2,
            tahun_ajaran_id: localStorage.getItem('tahun'),
            kode: null,
            tahun: localStorage.getItem('tahun')
        },
        kuesionerInduk: {
            rows: [],
            total: 0
        },
        kuesionerNomor: {
            rows: [],
            total: 0
        },
        dialogOpen: false,
        dialogText: '',
        buttonDialogText: '',
        dialogUrl: '',
        SnackbarOpen1: false,
        SnackbarOpen2: false,
        snackbarText: '',
        checkRadio: []
    }

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    componentDidMount = () => {

        // console.log(this.props.location.pathname.split('/')[3]);return true;

        if(typeof this.props.location.pathname.split('/')[3] !== 'undefined') {
            // this.state.nomor = this.props.location.pathname.split('/')[3];
            this.setState({
                nomor: this.props.location.pathname.split('/')[3]
            },()=>{
                this.props.history.push('/LembarInstrumen/'+this.props.location.pathname.split('/')[2]+'/'+this.state.nomor)
            })
        }

        // console.log('/LembarInstrumen/'+this.props.location.pathname.split('/')[2]+'/'+this.props.location.pathname.split('/')[3])


    };

    render()
    {
        const {classes} = this.props;
        // const {bottom, ListMenu} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <div style={{width: '100%', paddingBottom: '70px'}} className="kontenUtama" ref={div => (this.div = div)} onScroll={()=>{console.log('tes')}}>
                        {/* <Fab variant="extended" aria-label="Delete" className={classes.fab}>
                            <SaveIcon className={classes.extendedIcon} />
                            Simpan
                        </Fab> */}
                        <Button variant="extendedFab" className={classes.FabSimpan} color="primary" size="small" onClick={()=>{this.halamanSebelumnya()}} /*disabled={this.state.tombolDisabled}*/ style={{marginRight: 170, minWidth: '50px'}} disabled>
                            <ArrowBackIcon />
                            {/* <Typography style={{color:'white'}}></Typography> */}
                        </Button>
                        <Button variant="extendedFab" className={classes.FabSimpan} onClick={this.simpanKuesioner} style={{marginRight: 55}} disabled>
                            <SaveIcon className={classes.extendedIcon} />
                            Simpan
                        </Button>
                        <Button variant="extendedFab" className={classes.FabSimpan} color="primary" size="small" onClick={()=>{this.halamanBerikutnya()}} /*disabled={this.state.tombolDisabled}*/ style={{minWidth: '50px'}} disabled>
                            <ArrowForwardIcon />
                            {/* <Typography style={{color:'white'}}></Typography> */}
                        </Button>
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(android_asset/www/assets/images/backgrounds/pencil-book-2.jpg)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 89}}>
                            <Grid container spacing={16}>
                                <Grid item xs={10} sm={9} style={{paddingLeft: 10}}>
                                    <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>{this.state.kuesionerInduk.kode}. {this.state.kuesionerInduk.judul}</h1>
                                </Grid>
                                <Grid item xs={2} sm={3} style={{textAlign: 'right'}}>
                                {this.props.dirty === 1 &&
                                    <Badge badgeContent={<WarningIcon style={{color: '#F50002'}}/>} className={classes.margin} style={{marginRight: 10}}>
                                        <Button size="small" variant="contained" style={{margin: 'auto', marginRight: 0}} color="primary" className="buttonTambah" onClick={this.simpanKuesioner} disabled>
                                            <SaveIcon /> Simpan
                                        </Button>
                                    </Badge>
                                }
                                {this.props.dirty === 0 &&
                                    <Button size="small" variant="contained" style={{margin: 'auto', marginRight: 10}} color="primary" className="buttonTambah" onClick={this.simpanKuesioner} disabled>
                                        <SaveIcon /> Simpan
                                    </Button>
                                }
                                    <Button size="small" variant="contained" style={{margin: 'auto', minWidth: '40px'}} color="primary" className="buttonMenu" onClick={this.bukaMenuUtama} disabled>
                                        <MenuIcon style={{color:'white'}} />
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Perangkat Kuesioner"
                                className={this.props.classes.chip}
                                color="primary"
                                onClick={()=>{this.goTolink('/PerangkatKuesioner')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                            <Chip
                                label="> -.-"
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        {this.props.dirty === 1 &&
                        <Paper className={classes.paperWarningSave}>
                            <WarningIcon style={{fontSize: '12px'}}/> Terdapat jawaban yang belum tersimpan. Segera klik tombol simpan untuk menghindari hilangnya jawaban Anda!
                        </Paper>
                        }
                        <LinearProgress 
                            style={{height:10}} 
                            variant="determinate" 
                            value={this.state.persentase} 
                            classes={{
                                colorPrimary: classes.linearColorPrimary,
                                barColorPrimary: classes.linearBarColorPrimary,
                            }}
                        />
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setKuesioner: Actions.setKuesioner,
        getKuesioner: Actions.getKuesioner,
        setKuesionerDirty: Actions.setKuesionerDirty,
        setRadioKuesioner: Actions.setRadioKuesioner,
        simpanKuesioner: Actions.simpanKuesioner,
        hitungRekapKemajuan: Actions.hitungRekapKemajuan,
        getSekolah: Actions.getSekolah,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen
    }, dispatch);
}

function mapStateToProps({ Instrumen, Sekolah }) {

    // console.log(Instrumen.kuesioner);

    return {
        kuesioner: Instrumen.kuesioner,
        fetch_kuesioner: Instrumen.fetch_kuesioner,
        hasil_simpan: Instrumen.hasil_simpan,
        dirty: Instrumen.dirty,
        radioCheck: Instrumen.radioCheck,
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id
    }
}

// export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RaporSPMSekolah)));
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TransisiInstrumen)));





// WEBPACK FOOTER //
// ./src/main/content/Instrumen/TransisiInstrumen.js